import { CIcon } from '~/icons/types'

export const ciBoatParking: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.417 4 11.891 3 .457 4a.5.5 0 0 0-.456.5v2.477a.5.5 0 0 0 .5.5h.936v12.051a.5.5 0 0 0 .5.5h1.93a.5.5 0 0 0 .5-.5V7.477h15.141v12.051a.5.5 0 0 0 .5.5h1.929a.5.5 0 0 0 .5-.5V7.477h.938a.5.5 0 0 0 .5-.5V4.498A.5.5 0 0 0 23.417 4ZM3.367 19.028h-.93V7.477h.93v11.551Zm18.068 0h-.927V7.477h.929l-.002 11.551Zm1.438-12.551H1.001V4.956l10.89-.961 10.982.961v1.521Z'
    },
    {
      d:
        'M17.909 16.504h-1.616l2.072-4.637a.5.5 0 0 0-.456-.7 7.382 7.382 0 0 1-4.106-1.243l-1.59-1.06c-.008-.005-.02 0-.03-.008a.48.48 0 0 0-.246-.079.485.485 0 0 0-.248.076c-.01.005-.02 0-.03.008l-1.59 1.061a7.38 7.38 0 0 1-4.1 1.242.5.5 0 0 0-.455.7l2.072 4.637H5.965a.5.5 0 0 0 0 1h.539v2.024a.5.5 0 0 0 .5.5h1.608a.5.5 0 0 0 .5-.5v-2.02h5.495v2.023a.5.5 0 0 0 .5.5h1.609a.5.5 0 0 0 .5-.5v-2.024h.693a.5.5 0 1 0 0-1Zm-7.285-5.75.812-.543v3.025a.5.5 0 1 0 1 0v-3.025l.812.541a8.387 8.387 0 0 0 3.905 1.377l-1.955 4.375H8.676L6.72 12.13a8.359 8.359 0 0 0 3.903-1.376Zm-2.512 8.274h-.608v-1.524h.608v1.524Zm8.1 0h-.605v-1.524h.609l-.004 1.524Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'boat-parking',
  type: 'thin'
}
